import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import './app/utils/extension-methods';

import { AppModule } from '@app/app.module';
import { environment } from 'environments/environment';

if (environment.PRODUCAO) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
